export default {
    data: () => ({
        organizations: []
    }),
    methods: {
        async organizationGet() {
            const organizations = this.$communicator.then(
                this,
                await this.$communicator("organizations_get", {})
            );
            if (organizations instanceof Array) {
                this.organizations = organizations;
            }
            else {
                this.organizations = {}
            }
            return organizations

        },
        // async organizationPatch() {
        //     const organizations = this.$communicator.then(this, await this.$communicator("organizations_update",{params:this.organizations}))
        //     // if (organizations) {
        //     //     this.organizations = this.$copy(organizations)
        //     // }
        //     console.log(organizations)
        // }
    },
}